import { useMutation } from '@tanstack/react-query';

import * as API from '@krea/common/store/banking-data/api';

export const useFinalize = ({
  resourceId,
  resourceType,
}: {
  resourceId: string;
  resourceType: string;
}) => {
  return useMutation({
    mutationFn: ({ requisitionId }: { requisitionId: string }) =>
      API.finalize(resourceId, resourceType, requisitionId),
  });
};
